import {
  FarmFourCornerTagPayload,
  FarmTagResponse,
} from '@/models/FourCornerFarmTag'
import { post } from '@/utils/axios'

const postFourCornerFarmTag = async (farmTagObj: FarmFourCornerTagPayload) => {
  try {
    return await post<FarmTagResponse>('/farm/v1/boundary-coordinates', {
      ...farmTagObj,
    })
  } catch (e) {
    return null
  }
}

export default postFourCornerFarmTag
